import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { Grid } from '@material-ui/core'
import { PRIMARY_COLORS } from 'asterX-UI'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'

export const NotFound = ({ title = 'Не найдено' }) => {
  return (
    <Grid container justifyContent="center">
      <Grid
        style={{
          padding: '15px 30px',
          margin: 20,
          backgroundColor: PRIMARY_COLORS[100],
          borderRadius: 10,
          height: 'fit-content'
        }}
      >
        <AsterTypography
          variant="h6"
          style={{ display: 'flex', alignItems: 'center', gap: 10 }}
        >
          <ErrorOutlineOutlinedIcon />
          {title}
        </AsterTypography>
      </Grid>
    </Grid>
  )
}
